import React from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '../..';

import {
  Title,
  Footer,
  Container,
} from './BenchmarkConfirmationStyles';

type Props = {
  title: string;
  saveLabel: string;
  children: any;
  show: boolean;
  size?: 'lg' | 'sm' | 'xl';
  isLoading?: boolean;
  onClose: () => void;
  onSave: () => void;
}

const BenchmarkConfirmationModal: React.FC<Props> = ({
  title,
  saveLabel,
  children,
  show,
  size = 'lg',
  isLoading,
  onClose,
  onSave,
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size={size}
      dialogClassName="benchmarkConfirmationModal"
    >
      <Modal.Header
        closeButton
        style={{ paddingBottom: '0', borderBottom: 'none' }}
      >
        <Title>{title}</Title>
      </Modal.Header>
      <Modal.Body>
        <Container>{children}</Container>
        <Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSave} disabled={isLoading}>
            {saveLabel}
          </Button>
        </Footer>
      </Modal.Body>
    </Modal>
  );
};

export { BenchmarkConfirmationModal };
